import React from 'react';
import Button from './Button';
import iconsList from '../icons/iconsList';
import classes from './Button.module.scss';

const DownloadButton = ({ text, onClick, className, ...props }) => {

    return (
        <Button
            onClick={onClick}
            text={text}
            color="#FFF"
            borderColor="#070C43"
            iconName={iconsList.download}
            className={`${classes.downloadButton} ${className || ""}`}
            {...props}
        />
    );
};

export default DownloadButton;

